import styled from 'styled-components';

import { THEME_BLACK, themeColor, THEME_PRIMARY } from '../../../styles/basics/colors';
import MaterialIcon from '../../../shared/common/MaterialIcon';

export const StCampaignLabel = styled.span`
    display: inline-block;
    width: 50%;
`;

export const StCampaignValue = styled.span`
    width: 50%;
    font-size: 16px;
    font-weight: bold;
`;

export const StCampaignMetaLabel = styled.span`
    width: 116px;
    display: inline-block;
`;

export const StCampaignMetaValue = styled.span`
    font-size: 16px;
    font-weight: bold;
`;

export const StSubText = styled.span`
    font-size: 12px;
`;

StSubText.displayName = 'MetaDataStyles__StSubText';

export const StLoansLeftColor = styled.span`
    color: ${props => (props.color ? props.color : themeColor(THEME_BLACK))};
`;

export const StCampaignDatesWrapper = styled.div`
    margin-top: 10px;
    color: ${props => (props.color ? props.color : themeColor(THEME_BLACK))};
    white-space: nowrap;
`;

export const StCampaignCopiesWrapper = styled.div`
    margin-bottom: 10px;
    color: ${props => (props.color ? props.color : themeColor(THEME_BLACK))};
`;

export const StEditIcon = styled(MaterialIcon)`
    color: ${themeColor(THEME_PRIMARY)};
    vertical-align: top;
    cursor: pointer;
    margin-left: 10px;
    font-size: 16px;
`;

StEditIcon.displayName = 'MetaDataStyles__StEditIcon';
